import { render, staticRenderFns } from "./SendRequestReplyFacility.vue?vue&type=template&id=1f2ba314&scoped=true&lang=pug"
import script from "./SendRequestReplyFacility.vue?vue&type=script&lang=ts"
export * from "./SendRequestReplyFacility.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestReplyFacility.vue?vue&type=style&index=0&id=1f2ba314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ba314",
  null
  
)

export default component.exports